import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { Button } from "@/shared/components/ui/button";

interface UserDangerZoneSectionProps {
  readonly onDelete: () => void;
}

/** The admin-only danger zone: the entry point of the delete-user dialog. */
export function UserDangerZoneSection({ onDelete }: UserDangerZoneSectionProps) {
  const { t } = useTranslation();
  return (
    <section
      data-testid="user-detail-danger-zone"
      className="rounded-lg border border-destructive/30 bg-destructive/5 p-6"
    >
      <h2 className="brand-eyebrow mb-4 text-destructive">{t("users.detail.dangerZone")}</h2>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <p className="max-w-lg font-sans text-sm font-normal text-muted-foreground">
          {t("users.delete.sectionHint")}
        </p>
        <Button data-testid="open-delete-user" variant="destructive" onClick={onDelete}>
          <Trash2 className="mr-2 h-4 w-4" />
          {t("users.actions.delete")}
        </Button>
      </div>
    </section>
  );
}
